import { Box } from '@mui/material';
import React from 'react';

// The gold "Beta" pill: sidebar items, and headings of features still in beta
// (Autopilot). `solid` (gold fill, white text) sits inside a chip that is
// already tinted gold — the "Autopilot on" chip — where the tint pill would
// vanish.
export function BetaPill({ solid = false }: { solid?: boolean } = {}) {
    return (
        <Box
            component="span"
            sx={{
                font: '700 9px/1 CircularStd, sans-serif',
                letterSpacing: '.04em',
                textTransform: 'uppercase',
                px: '5px',
                py: '2.5px',
                borderRadius: 999,
                bgcolor: solid ? 'var(--accent)' : 'var(--tint)',
                color: solid ? '#fff' : 'var(--accent-text)',
                flex: 'none',
                display: 'inline-block',
                verticalAlign: 'middle'
            }}
        >
            Beta
        </Box>
    );
}
